import { render } from "./ConsultingDetailMonitoring.vue?vue&type=template&id=499a341a"
import script from "./ConsultingDetailMonitoring.vue?vue&type=script&lang=js"
export * from "./ConsultingDetailMonitoring.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__